import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M1.49902 13.4991L19.289 13.4991L13.844 20.0391C13.5894 20.3454 13.4669 20.7403 13.5035 21.137C13.5401 21.5336 13.7327 21.8995 14.039 22.1541C14.3453 22.4087 14.7403 22.5312 15.1369 22.4946C15.5335 22.4581 15.8994 22.2654 16.154 21.9591L23.654 12.9591C23.7045 12.8875 23.7496 12.8123 23.789 12.7341C23.789 12.6591 23.789 12.6141 23.894 12.5391C23.962 12.3671 23.9976 12.184 23.999 11.9991C23.9976 11.8142 23.962 11.6311 23.894 11.4591C23.894 11.3841 23.894 11.3391 23.789 11.2641C23.7496 11.1859 23.7045 11.1107 23.654 11.0391L16.154 2.0391C16.013 1.86978 15.8364 1.7336 15.6368 1.64027C15.4371 1.54694 15.2194 1.49874 14.999 1.4991C14.6485 1.49841 14.3089 1.62047 14.039 1.8441C13.8871 1.97002 13.7616 2.12467 13.6696 2.29919C13.5775 2.47371 13.5208 2.66467 13.5027 2.86114C13.4846 3.0576 13.5054 3.25571 13.564 3.44412C13.6226 3.63252 13.7177 3.80752 13.844 3.9591L19.289 10.4991L1.49902 10.4991C1.1012 10.4991 0.719668 10.6571 0.438363 10.9384C0.157058 11.2197 -0.00097561 11.6013 -0.000975644 11.9991C-0.000975679 12.3969 0.157058 12.7785 0.438363 13.0598C0.719668 13.3411 1.1012 13.4991 1.49902 13.4991Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
